export const externalLinkWarningMessages = {
  'External Link': 'formforge.preview.tnc.external_link_title',
  'You are about to open an external link. Do you want to continue?':
    'formforge.preview.tnc.external_link_subtitle',
} as const;

export type ExternalLinkWarningMessageKey =
  keyof typeof externalLinkWarningMessages;
